import { useEffect, useState, useMemo } from "react";
import { useRequest } from "ahooks";
import { getProjectPaymentNodes } from "@/services";
import { ThSpinWithEmpty } from "@/components";
import ProjectTimeline from "./Timeline";
import styles from './index.module.scss'
import { getMilestoneData } from '../milestone/index'

type Props = {
  projectID: number,
  contracts?: API.PROJECT.Contract[]
};

const ProjectPaymentNodes: React.FC<Props> = (props) => {
  const { projectID, contracts } = props;

  const [currentContract, setCurrentContract] = useState<API.PROJECT.Contract | undefined>(contracts ? contracts[0] : undefined); 

  const {data: paymentNodes, loading, run: runGetPaymentNodes } = useRequest(getProjectPaymentNodes, {
    manual: true
  });
  const { data: milestones, loading: milestoneLoading } = useRequest(getMilestoneData, {
    defaultParams: [projectID]
  });

  useEffect(()=>{
    if(!currentContract) return
    runGetPaymentNodes(projectID, currentContract.contractCode)
  }, [currentContract, projectID, runGetPaymentNodes])

  return (
    <div style={{ minHeight: 520 }}>
      <div className="flex flex-wrap gap-3 mb-12">
        {contracts && contracts.map(item => (
          <div key={item.contractCode} 
          className={`${styles.containerItem} 
          ${currentContract?.contractCode === item.contractCode ? styles.selected : ''}`} 
          onClick={() => setCurrentContract(item)}>{item.contractName}</div>
        ))}
      </div>
      
      <ThSpinWithEmpty
        loading={loading}
        active={paymentNodes && paymentNodes.length > 0}
        empty={{
          description: (
            <div className="text-black/25 mt-4">
              {loading || milestoneLoading ? '数据加载中' : '暂无数据'}
            </div>
          )
        }}
      >
        <ProjectTimeline data={paymentNodes} milestones={milestones} />
      </ThSpinWithEmpty>
    </div>
  );
};

export default ProjectPaymentNodes;
